import { useT } from '../i18n';
import { describeError } from '../lib/errors';

export function ErrorBlock({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const t = useT();
  return (
    <div role="alert" className="card my-4 border-bad/50">
      <p className="text-bad">{t(describeError(error))}</p>
      {onRetry ? (
        <button type="button" className="btn mt-3 w-full" onClick={onRetry}>
          {t('common.retry')}
        </button>
      ) : null}
    </div>
  );
}
